import httpClient from "./httpClient";

// Normaliza a resposta do backend para um shape estável consumido pelo hook.
const normalize = (raw, page, limit) => ({
  data: raw?.data ?? [],
  totalResult: raw?.totalResult ?? 0,
  totalPages: raw?.totalPages ?? 0,
  page: raw?.page ?? page,
  limit: raw?.limit ?? limit,
});

export const createPaginatedResource = (resourcePath) => ({
  fetchPage: async ({
    page = 1,
    limit = 10,
    empresa,
    search,
    filters = {},
    cancelToken,
  }) => {
    const body = { page, limit, filters: { empresa, ...filters }, search };
    const { data } = await httpClient.post(resourcePath, body, { cancelToken });
    return normalize(data, page, limit);
  },
});

export const ordersResource = createPaginatedResource("/v2/orders");
export const equipmentsResource = createPaginatedResource("/v2/equipments");
export const requestsResource = createPaginatedResource("/v2/requests");
